/**
 * @param {import("vue-router").Route} route
 */
export default function (route) {
  let documentTitle;
  switch (route.name) {
    case 'StartAanbod':
      documentTitle = route.params.aanbod;
      break;
    case 'Page':
      documentTitle = `${route.params.subflow} - ${route.params.page}`;
      break;
    default:
      documentTitle = route.meta?.title;
      break;
  }

  return `Xerius - ${documentTitle}`;
}
